export default {
  app: {
    name: 'Moroorato',
    panel: 'Moroorato Admin Panel',
    tagline: 'Adaptive Konkur learning platform',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    search: 'Search',
    searchPlaceholder: 'Search…',
    loading: 'Loading…',
    empty: 'No results found',
    retry: 'Retry',
    refresh: 'Refresh',
    create: 'Create',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    confirm: 'Confirm',
    view: 'View',
    details: 'Details',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    actions: 'Actions',
    status: 'Status',
    none: '—',
    total: 'Total',
    page: 'Page',
    of: 'of',
    filters: 'Filters',
    clear: 'Clear',
    apply: 'Apply',
    optional: 'optional',
    required: 'required',
    copy: 'Copy',
    copied: 'Copied',
    saved: 'Saved successfully',
    error: 'Something went wrong',
    notImplemented: 'This section is not available yet',
    toastSuccess: 'Success',
    toastError: 'Error',
  },
  nav: {
    overview: 'Overview',
    dashboard: 'Dashboard',
    // `nav.commandCenter` and `nav.integrations` have been in fa.js and missing here long enough that
    // `npm run lint:i18n` — a HARD parity gate — has been failing on them; a red gate teaches everyone
    // to ignore it, which is worse than either missing key. Added rather than allow-listed, because an
    // allow-list entry says «this divergence is intentional» and neither of these was.
    //
    // Both keys are dead as of 2026-09-04: the sidebar reads `meta.navLabel ?? meta.title` from the
    // route table now, and the whole `nav` block is unreferenced except `nav.profile`. See fa.js's
    // header. They are kept in parity so the gate is green while the dead keys are retired in one pass.
    commandCenter: 'Action Center',
    integrations: 'Integrations',
    learners: 'Learners',
    questionBank: 'Question Bank',
    questions: 'All Questions',
    reviewQueue: 'Review Queue',
    generate: 'AI Generation',
    quality: 'Question Quality',
    misconceptions: 'Misconceptions',
    curriculum: 'Curriculum',
    concepts: 'Concepts',
    relationships: 'Concept Relationships',
    examWindows: 'Exam Windows',
    plm: 'Learner Model (PLM)',
    plmValidation: 'Model Validation',
    plmExperiments: 'A/B Experiments',
    content: 'Content & Engagement',
    messages: 'Messages',
    faq: 'FAQ',
    account: 'Account',
    profile: 'Profile',
    engagement: 'Engagement & Subscriptions',
    revenue: 'Revenue & Subscriptions',
    subscriptionPlans: 'Subscription Plans',
    subscriptions: 'Subscriptions',
    deletionQueue: 'Deletion Queue',
    notifications: 'Notification Management',
    leagues: 'Leagues',
    competitions: 'Competitions',
    accessControl: 'Access Control',
    adminManagement: 'Admin Management',
    adminRoles: 'Roles & Permissions',
    auditLog: 'Audit Log',
    systemSettings: 'System Settings',
    featureFlags: 'Feature Flags',
    revenueAnalytics: 'Revenue Analytics',
    gamificationEconomy: 'Gamification Economy',
    growthSection: 'Growth & Experiments',
    experiments: 'Experiment Management',
    productAnalytics: 'Product Analytics',
    platformOps: 'Platform Operations',
    systemHealth: 'System Health',
    queueMonitor: 'Queue Monitor',
    outboxQueue: 'Outbox Queue',
    cronSchedule: 'Cron Schedule',
    misconceptionLibrary: 'Misconception Library',
    questionCoverage: 'Coverage & Bulk Ops',
    curriculumVersions: 'Curriculum Versions',
    graphAudit: 'Graph & Mapping Audit',
    securityEvents: 'Security & Sessions',
    learnerOps: 'Bulk Ops & Stats',
    leagueManagement: 'League Management',
    notificationDelivery: 'Notification Delivery',
    commsLog: 'Comms & SMS Log',
    batchOperations: 'Batch Operations',
    plmEvents: 'Events & Anomalies',
    populationLearning: 'Population Learning',
    segments: 'Student groups',
    examBlueprint: 'Exam Blueprint & Capacity',
    actionApprovals: 'Action Approvals',
    compliance: 'Compliance & Data Export',
    deletionLifecycle: 'Deletion Lifecycle',
    guardians: 'Guardian Contacts',
    schoolConsole: 'Schools & Classes',
    schoolAnalytics: 'School Engagement',
    schoolClasses: 'Class Management',
    globalSearch: 'Global Search',
    alertInbox: 'Alert Inbox',
    contentModeration: 'Content Moderation',
    coupons: 'Coupons',
    appConfig: 'App Version & Remote Config',
    forecastAudit: 'Forecast & Access Audit',
    streakHealth: 'Streak Health',
    coverageHeatmap: 'Content Coverage Heatmap',
    questionCalibration: 'Question Calibration',
    subjectBalance: 'Subject Balance Monitor',
    examCountdown: 'Exam Countdown',
    retentionCohorts: 'Retention Cohorts',
    atRiskLearners: 'At-Risk Early Warning',
    mockExamAnalytics: 'Mock Exam Analytics',
    fsrsHealth: 'FSRS Memory Health',
    examReadiness: 'Model Readiness Estimates',
    weaknessMap: 'Model-Based Concept Weaknesses',
    cognitivePerformance: 'Answering Patterns',
    learningGains: 'Learning Gain Ledger',
    growthTrend: 'DAU/MAU Growth Trend',
    campaignEffectiveness: 'Campaign Effectiveness',
    churnTimeline: 'Churn flow',
    contentGap: 'Content Gap Analysis',
    aiGenerationQuality: 'AI Generation Quality',
    difficultyDrift: 'Difficulty Drift',
    prerequisiteViolations: 'Weak Prerequisite Review',
    goalProgress: 'Goal Progress',
    milestones: 'Learning Milestones',
    liveSessions: 'Live Sessions',
    endpointLatency: 'Endpoint Latency',
    slowQueries: 'Slow Queries',
  },
  auth: {
    signInTitle: 'Sign in to the admin panel',
    signInSubtitle: 'Enter your email and password to continue.',
    email: 'Email',
    password: 'Password',
    show: 'Show',
    hide: 'Hide',
    submit: 'Sign in',
    signingIn: 'Signing in…',
    invalid: 'Email or password is incorrect.',
    welcome: 'Welcome to the Moroorato Admin Panel',
    welcomeBody: 'Manage learners, the question bank, curriculum and the learner model in one place.',
    logout: 'Sign out',
    loggedOut: 'You have been signed out',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Operational overview of the platform',
    learners: 'Learners',
    admins: 'Admins',
    activeExamWindows: 'Active exam windows',
    faqCategories: 'FAQ categories',
    publishedMessages: 'Published messages',
    practiceSessions: 'Practice sessions',
    competitionMatches: 'Competition matches',
    systemStatus: 'System status',
    database: 'Database',
    apiRuntime: 'API runtime',
    realtimeGateway: 'Realtime gateway',
    eventStream: 'Event stream',
    generatedAt: 'Updated at',
    statusOk: 'healthy',
    statusConfigured: 'configured',
    statusPlanned: 'planned',
  },
  learners: {
    title: 'Learners',
    subtitle: 'Search and inspect the learner model',
    searchPlaceholder: 'Name, email or phone…',
    field: 'Field',
    grade: 'Grade',
    name: 'Name',
    phone: 'Phone',
    joinedAt: 'Joined',
    openModel: 'Learner model',
    inspector: 'Learner model inspector',
    practiceSessions: 'Practice sessions',
    noProfile: 'No name',
  },
  subscriptions: {
    title: 'Subscriptions',
    subtitle: 'View, grant and revoke premium subscriptions',
    searchPlaceholder: 'Name, email or phone…',
    plan: 'Plan',
    status: 'Status',
    source: 'Source',
    expiresAt: 'Expires',
    grantTitle: 'Grant premium subscription',
    grantSubtitle: 'Activate a premium subscription for a learner without going through the payment gateway.',
    userId: 'Learner ID (numeric)',
    planKey: 'Plan key',
    durationDays: 'Days (blank = plan default)',
    grant: 'Grant',
    revokeConfirm: 'Are you sure you want to revoke this subscription?',
    revoke: 'Revoke',
    active: 'Active',
    expired: 'Expired',
    revoked: 'Revoked',
  },
  deletionQueue: {
    title: 'Deletion Queue',
    subtitle: 'Pending account deletion requests — can be cancelled before the purge job runs',
    searchPlaceholder: 'Name, email or phone…',
    requestedAt: 'Requested',
    confirmedAfter: 'Purge after',
    reason: 'Reason',
    cancelConfirm: 'Are you sure you want to cancel the deletion request for this user?',
    cancel: 'Cancel deletion',
    purgeImminent: 'Purge imminent',
    noRequests: 'No pending deletion requests.',
  },
  plm: {
    dimensions: 'Dimensions',
    knowledge: 'Knowledge',
    memory: 'Memory',
    confidence: 'Confidence',
    misconception: 'Misconception',
    cognitive: 'Cognitive',
    behavior: 'Behavior',
    weakness: 'Weakness map',
    readiness: 'Exam readiness',
    opportunities: 'Learning opportunities',
    recommendations: 'Recommendations',
    gain: 'Learning gain',
    forecast: 'Digital twin (forecast)',
    validationTitle: 'Model validation & calibration',
    experimentsTitle: 'Recommendation A/B experiments',
  },
}
